import { Component } from '@angular/core';
import { Platform, MenuController } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';

// import { FCM } from '@ionic-native/fcm/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  appPages = [
    {
      title: 'menu',
      url: '/app/tabs/menu',
      icon: 'home'
    },
    {
      title: 'Tab1',
      url: '/app/tabs/tab1',
      icon: 'contacts'
    },
    {
      title: 'Tab2',
      url: '/app/tabs/tab2',
      icon: 'map'
    },
    {
      title: 'Tab2',
      url: '/app/tabs/tab3',
      icon: 'information-circle'
    }
  ];

  loggedIn = false;
  dark = false;  
  loader:any

  constructor(
    private platform: Platform,
    public menu: MenuController,
    private splashScreen: SplashScreen,
    private router: Router,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    private storage: Storage,
    // private fcm: FCM,
    private translate: TranslateService
  ) {
    this.initializeApp();
  }


  initializeApp() {
    this.platform.ready().then(async () => {
      await this.storage.create();
      this.splashScreen.hide();

      this.translate.setDefaultLang('es');
      this.translate.use('es');
    });

    // this.fcm.getToken()
    // .then(token => {
    //   localStorage.setItem("tokenPush",token)
    // }) 
    // .catch(error => {
    //   console.log(error)
    // });
  }
  
  startApp(provider) {
    // If the provider returned by detectEthereumProvider is not the same as
    // window.ethereum, something is overwriting it, perhaps another wallet.
    /* if (provider !== window.ethereum) {
      console.error('Do you have multiple wallets installed?');
    } */
    // Access the decentralized web!
  }

  public switchLanguage(language: string){
    this.translate.use(language);
    console.log(language)
  }


  openTutorial() {
    this.menu.enable(false);
    this.storage.set('ion_did_tutorial', false);
    this.router.navigateByUrl('/menu');
  }

  /**
  *
  * validacion de errorres por mensaje
  *
  */
  async presentAlert(tit, subtit, msm, rutaAcept:any, rutaCancel, backdropDismiss=false) {
    var buttons = []
    var bcancel = {
      text: this.translate.store.translations[this.translate.store.currentLang]['DISMISS'],
      handler: () => {
        // this.UserProvider.logout().subscribe( (data) => {
        //   console.log("LOGOUT GOOD")
        //   localStorage.clear();
        // } , (error) => {
        //   console.log(error)
        //   console.log("LOGOUT BAD")
        //   localStorage.clear();
        // } );

        // this.wait();
        
      }
    }
    var bacept = null;
    if(rutaAcept){
      if(rutaAcept.openweb){
        bacept = {
          text: 'Ver in Navegador',
          handler: () => {
            
            window.open(rutaAcept.ruta, '_blank', 'location=yes');

              /*if(rutaAcept == "refreshTokenCoinbase")
                  this.refreshTokenCoinbase();
              else if(rutaAcept=="retryMenu")
                  this.getMenu();
              else if(rutaAcept=="retryMember")
                  this.getMemberCurrent();
              else
                  this.nav.setRoot('LobbyBarterPage'); */
          }
        }

      }

    }
    if(bcancel)
    buttons.push(bcancel)
    if(bacept)
    buttons.push(bacept)
    const alert = await this.alertCtrl.create({
          header: this.translate.store.translations[this.translate.store.currentLang][tit] ? this.translate.store.translations[this.translate.store.currentLang][tit] : tit,
          subHeader: this.translate.store.translations[this.translate.store.currentLang][subtit] ? this.translate.store.translations[this.translate.store.currentLang][subtit] : subtit,
          message: this.translate.instant(msm) ? this.translate.instant(msm) : msm,
          buttons: buttons, 
          backdropDismiss: backdropDismiss
      });
      alert.present();
  }

  
  async presentMessageAlertConfirm(header: string, message: string, buttonNokText: string, buttonOkText: string, 
    backdropDismiss: boolean, callback: () => void = function() {}, callbackNok: () => void = function() {}
  ) {
    let alert = await this.alertCtrl.create({
      header: header,
      message: message,
      backdropDismiss: backdropDismiss,
      cssClass:'alertConfirm',
      buttons: [
        {
          text: buttonNokText,
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            callbackNok();
          }
        },
        {
          text: buttonOkText,
          handler: () => {
            callback();
          }
        }
      ]
    });

    await alert.present();
  }

  async presentLoading(message) {
    
    let loader = await this.loadingCtrl.create({
      message: message,
      duration: 4
    });
    loader.present();
  }
  async presentLoadingAdvanced(message, action) {
    if(action == 'show'){
      this.loader = await this.loadingCtrl.create({
        message: this.translate.instant(message) ? this.translate.instant(message) : message,
      });
      await this.loader.present();
    }else if(action == "dismiss"){
      await  this.loader.dismiss();
    }else if(action == "modify"){
      this.loader = await this.loadingCtrl.create({
        message: this.translate.instant(message) ? this.translate.instant(message) : message,
      });
    }
  }

  async showLongToast(msg, color='dark') {
    const toast = await this.toastCtrl.create({
      message: msg,
      color,
      duration: 2000,
    });
    return toast.present();
  }

  // Query for the toggle that is used to change between themes
// const toggle = document.querySelector('#themeToggle');

// // Listen for the toggle check/uncheck to toggle the dark class on the <body>
// toggle.addEventListener('ionChange', (ev) => {
//   document.body.classList.toggle('dark', ev.detail.checked);
// });

// const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

// // Listen for changes to the prefers-color-scheme media query
// prefersDark.addListener((e) => checkToggle(e.matches));

// // Called when the app loads
// function loadApp() {
//   checkToggle(prefersDark.matches);
// }

// // Called by the media query to check/uncheck the toggle
// function checkToggle(shouldCheck) {
//   toggle.checked = shouldCheck;
// }

}
